import { Host, h } from '@stencil/core';
export class AibaAnalysisGraphView {
  constructor() {
    this.componentWillLoad = async () => {
      if (this.handlers && this.handlers.handleGraphViewLoad) {
        let dataFromViewLoad = await this.handlers.handleGraphViewLoad();
        if (dataFromViewLoad) {
          this.donutData = dataFromViewLoad;
        }
      }
      if (this.handlers && this.handlers.handleGraphViewLoadToGetActiveDonut) {
        const { donutData, activateId, accordionItems } = await this.handlers.handleGraphViewLoadToGetActiveDonut();
        if (donutData)
          this.donutData = donutData;
        if (activateId)
          this.activateId = activateId;
        if (accordionItems)
          this.accordionItems = accordionItems;
      }
    };
    this.data = undefined;
    this.propDonutData = {};
    this.handlers = undefined;
    this.activateId = '';
    this.donutData = this.propDonutData;
    this.contentData = undefined;
    this.activeDonut = undefined;
    this.accordionItems = undefined;
    this.renderSkinAttributesDescription = false;
  }
  handleDonutClick(event, techName, data, donutInfo) {
    console.log('event' + event);
    this.contentData = data;
    if (this.contentRef) {
      const contentElement = this.contentRef;
      if (contentElement) {
        setTimeout(() => {
          window.scrollTo({
            top: contentElement === null || contentElement === void 0 ? void 0 : contentElement.offsetTop,
            behavior: 'smooth',
          });
        }, 500);
      }
    }
    this.activateId = techName;
    this.activeDonut = techName;
    const eventDetails = {
      event,
      techName,
      data,
      donutInfo,
    };
    this.infoSelfieAttributeClicked.emit(eventDetails);
    this.handlers && this.handlers.handleAnalysisGraphDonutClick && this.handlers.handleAnalysisGraphDonutClick(event, donutInfo);
  }
  toggleSkinAttributesDescription(e) {
    this.renderSkinAttributesDescription = !this.renderSkinAttributesDescription;
    this.handlers && this.handlers.handleToggleSkinAttributesDescription && this.handlers.handleToggleSkinAttributesDescription(e);
  }
  render() {
    var _a, _b, _c;
    this.data = ((_a = this.data) === null || _a === void 0 ? void 0 : _a.data) ? (_b = this.data) === null || _b === void 0 ? void 0 : _b.data : this.data;
    return (h(Host, null, this.data &&
      ((_c = this.data) === null || _c === void 0 ? void 0 : _c.elements.map((element) => {
        var _a, _b;
        if (element.name === 'aiba-prompt') {
          return h("aiba-prompt", { data: element['data'], classes: element && element['data'] && element['data']['classes'] ? element['data']['classes'] : '' });
        }
        if (element && element['name'] === 'aiba-label') {
          return h("aiba-label", Object.assign({}, element['data']));
        }
        if (element.name === 'aiba-donut-view') {
          return element.data.elements.map((item) => {
            var _a, _b;
            return (item.name === 'aiba-donut' &&
              ((_b = (_a = this.donutData) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.map((dountInfo, index) => {
                if (!this.activateId && index === 0) {
                  this.activateId = dountInfo.algorithmTechName;
                  this.handlers && this.handlers.handleFirstDonutOnLoad && this.handlers.handleFirstDonutOnLoad(dountInfo);
                }
                return (h("div", { key: dountInfo.algorithmTechName, class: 'donut-circle donut-circle' + index }, h("aiba-donut", { handleClick: (event) => this.handleDonutClick(event, dountInfo.algorithmTechName, dountInfo.info, dountInfo), value: (dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.value) ? dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.value : dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.value, content: Object.assign({}, dountInfo), variant: dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.status, class: this.activateId === dountInfo.algorithmTechName ? 'active' : '', data: item['data'], renderForModal: false, size: dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.size, borderWidth: (dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.borderWidth) ? dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.borderWidth : 10, active: this.activeDonut ? this.activeDonut === dountInfo.algorithmTechName : index === 0 })));
              })));
          });
        }
        if (element.name === 'aiba-result-content-block') {
          return (h("aiba-result-content-block", { data: element['data'], content: this.contentData ? this.contentData : ((_a = this.donutData) === null || _a === void 0 ? void 0 : _a.data[0].info) ? (_b = this.donutData) === null || _b === void 0 ? void 0 : _b.data[0].info : null, ref: el => (this.contentRef = el) }));
        }
        if (element.name === 'aiba-top-results-donut-view') {
          return (h("div", { class: "top-results-donut-view-wrapper" }, element.data.elements.map((item) => {
            var _a, _b;
            if (item && item.name === 'aiba-donut') {
              return (_b = (_a = this.donutData['top-results']) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.map((dountInfo, index) => {
                if (!this.activateId && index === 0) {
                  this.activateId = dountInfo.algorithmTechName;
                  this.handlers && this.handlers.handleFirstDonutOnLoad && this.handlers.handleFirstDonutOnLoad(dountInfo);
                }
                return (h("div", { key: dountInfo.algorithmTechName, class: 'donut-circle donut-circle' + index }, h("aiba-donut", { handleClick: (event) => this.handleDonutClick(event, dountInfo.algorithmTechName, dountInfo.info, dountInfo), value: (dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.value) ? dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.value : dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.value, content: Object.assign({}, dountInfo), variant: dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.status, class: this.activateId === dountInfo.algorithmTechName ? 'active' : '', data: item['data'], renderForModal: false, size: dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.size, borderWidth: (dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.borderWidth) ? dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.borderWidth : 10, active: this.activeDonut ? this.activeDonut === dountInfo.algorithmTechName : index === 0 })));
              });
            }
            if (item && item['name'] === 'aiba-label') {
              return h("aiba-label", Object.assign({}, item['data']));
            }
          })));
        }
        if (element.name === 'aiba-concerns-donut-view') {
          return (h("div", { class: "top-concerns-donut-view-wrapper" }, element.data.elements.map((item) => {
            var _a, _b;
            if (item && item.name === 'aiba-donut') {
              return (_b = (_a = this.donutData['concerns']) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.map((dountInfo, index) => {
                if (!this.activateId && index === 0) {
                  this.activateId = dountInfo.algorithmTechName;
                  this.handlers && this.handlers.handleFirstDonutOnLoad && this.handlers.handleFirstDonutOnLoad(dountInfo);
                }
                return (h("div", { key: dountInfo.algorithmTechName, class: 'donut-circle donut-circle' + index }, h("aiba-donut", { handleClick: (event) => this.handleDonutClick(event, dountInfo.algorithmTechName, dountInfo.info, dountInfo), value: (dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.value) ? dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.value : dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.value, content: Object.assign({}, dountInfo), variant: dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.status, class: this.activateId === dountInfo.algorithmTechName ? 'active' : '', data: item['data'], renderForModal: false, size: dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.size, borderWidth: (dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.borderWidth) ? dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.borderWidth : 10, active: this.activeDonut ? this.activeDonut === dountInfo.algorithmTechName : index === 0 })));
              });
            }
            if (item && item['name'] === 'aiba-label') {
              return h("aiba-label", Object.assign({}, item['data']));
            }
          })));
        }
        if (element.name === 'aiba-skin-attributes-description' && this.renderSkinAttributesDescription) {
          return (h("div", { class: "skin-attributes-description" }, element.data.elements.map((item) => {
            if (item && item.name === 'aiba-accordion-map') {
              return h("aiba-accordion-map", Object.assign({}, element['data'], { handlers: this.handlers, items: this.accordionItems ? this.accordionItems : item['data']['items'] }));
            }
            if (item && item.name === 'aiba-label') {
              return h("aiba-label", Object.assign({}, item['data']));
            }
            if (item && item.name === 'aiba-button' && item._id && item._id === 'toggle-skin-attributes-description') {
              return h("aiba-button", Object.assign({}, item === null || item === void 0 ? void 0 : item.data, { handleClick: (e) => this.toggleSkinAttributesDescription(e) }));
            }
          })));
        }
        if (element.name === 'aiba-buttons-wrapper') {
          return (h("div", { class: "toggle-skin-attributes-description-btn-wrapper" }, element['data'] &&
            element['data']['elements'] &&
            element['data']['elements'].map((nestedElem) => {
              if (nestedElem && nestedElem.name === 'aiba-button' && nestedElem._id && nestedElem._id === 'toggle-skin-attributes-description') {
                return (h("aiba-button", Object.assign({}, nestedElem === null || nestedElem === void 0 ? void 0 : nestedElem.data, { handleClick: (e) => this.toggleSkinAttributesDescription(e), value: this.renderSkinAttributesDescription ? nestedElem['data']['open']['value'] : nestedElem['data']['value'], title: this.renderSkinAttributesDescription ? nestedElem['data']['open']['title'] : nestedElem['data']['title'], path: this.renderSkinAttributesDescription ? nestedElem['data']['open']['path'] : nestedElem['data']['path'], pathWithHover: this.renderSkinAttributesDescription ? nestedElem['data']['open']['pathWithHover'] : nestedElem['data']['pathWithHover'], iconAlt: this.renderSkinAttributesDescription ? nestedElem['data']['open']['iconAlt'] : nestedElem['data']['iconAlt'] })));
              }
            })));
        }
      }))));
  }
  static get is() { return "aiba-analysis-graph-view"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-analysis-graph-view.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-analysis-graph-view.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "propDonutData": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "prop-donut-data",
        "reflect": false,
        "defaultValue": "{}"
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "activateId": {},
      "donutData": {},
      "contentData": {},
      "activeDonut": {},
      "accordionItems": {},
      "renderSkinAttributesDescription": {}
    };
  }
  static get events() {
    return [{
        "method": "infoSelfieAttributeClicked",
        "name": "infoSelfieAttributeClicked",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
}
//# sourceMappingURL=aiba-analysis-graph-view.js.map
